// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2C7dv","rightAdornment":"Header_rightAdornment__2_xZs"};